import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideThreeC, ThreeCFormData } from './types'

export const useThreeCUpdate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isUpdating, setIsUpdating] = useState(false)

  const updateThreeC = async (
    id: string,
    data: ThreeCFormData,
    setThreeC: (threeC: SlideThreeC) => void
  ) => {
    if (!id) return

    setIsUpdating(true)

    try {
      const response = await apiClient.business.slideThreecUpdateUpdate({
        businessIdeaId: id,
        ...data,
      })

      if (response.data?.threeC) {
        setThreeC(response.data.threeC)
        showSnackBar(['3C分析を更新しました'], 'success')
      }
    } catch (e) {
      console.error('3C分析の更新に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updateThreeC,
  }
}
